import state from './moduleHRMSState.js'
import mutations from './moduleHRMSMutations.js'
import actions from './moduleHRMSActions.js'
import getters from './moduleHRMSGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}